import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useRef, useState } from "react";
import { useDrawerAnimation } from "../../../shared/animation";
import { useDisableScroll, useFocusTrap } from "../../../shared/hooks";
import { MembershipStatus } from "../../../shared/types";
import { Menu } from "../../Icons";
import { forBusinessesCategories as initForBusinessesCategories, learnCategories as initLearnCategories } from "../links";
import { combinedProducts as initCombinedProducts, productCategories } from "../productLinks";
import MenuContainer from "./MenuContainer";
import * as S from "./styles";
export var MobileMenu = function MobileMenu(_ref) {
  var e = _ref.loggedIn,
      t = _ref.isLoggingIn,
      i = _ref.accountLinks,
      r = _ref.topLevelLinks,
      o = _ref.membership,
      s = _ref.onLogout,
      n = _ref.root,
      a = _ref.ehsRoot,
      m = _ref.onMenuItemClick,
      u = _ref.renderLinkAs;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      l = _useState2[0],
      c = _useState2[1],
      p = useDrawerAnimation(l),
      d = useRef();

  useDisableScroll(l), useFocusTrap(d, l);

  var g = function g(_ref2) {
    var e = _ref2.type;
    return "".concat(n || "", "/").concat(e, "-membership");
  },
      b = function b(_ref3) {
    var e = _ref3.creditsAvailable,
        t = _ref3.state;
    return e ? "".concat(e, " free ").concat(1 === e ? "test" : "tests", " available") : t === MembershipStatus.Active ? "20% sitewide savings" : "";
  },
      C = function C(e) {
    m && m("Site Nav (Mobile) - " + e);
  },
      L = function L(e) {
    m && m("Site Nav (Mobile) - Filtered PIP Link - " + e.categoryName);
  },
      k = initLearnCategories(n),
      f = initForBusinessesCategories(n, a),
      h = initCombinedProducts(n);

  return React.createElement(React.Fragment, null, React.createElement(S.Hamburger, {
    "aria-label": "Open Menu",
    onClick: function onClick() {
      c(!0), m && m("Site Nav (Mobile) - Shop");
    },
    "data-testid": "mobile-hamburger-menu"
  }, React.createElement(Menu, null)), p(function (a, m) {
    return m && React.createElement(MenuContainer, {
      values: a,
      drawerRef: d,
      setOpen: c,
      topLevelLinks: r,
      handleLinkClick: C,
      handleFilteredPipLinkClick: L,
      productCategories: productCategories,
      combinedProducts: h,
      loggedIn: e,
      isLoggingIn: t,
      accountLinks: i,
      membership: o,
      learnCategories: k,
      forBusinessesCategories: f,
      membershipLink: g,
      membershipSubText: b,
      onLogout: s,
      root: n,
      renderLinkAs: u
    });
  }));
};
export default MobileMenu;